// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Sf-z","bodyOpen":"Tf-z","content":"Uf-z","header":"Vf-z","close":"Wf-z","closeNoHeading":"Xf-z"};